import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";
import AuthenticatedProfile from "./AuthenticatedProfile";
import UnauthenticatedProfile from "./UnauthenticatedProfile";

const MyProfile = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);

  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false); // State to manage dropdown expansion

  // Retrieve username from sessionStorage, fallback to null
  const dummyUsername = sessionStorage.getItem("username");

  const handleLogout = (event) => {
    event.preventDefault();
    console.log("Logged out");
    navigate("/home");
  };

  const handleResetPassword = (event) => {
    event.preventDefault();
    navigate("/resetPassword/:token");
  };

  const toggleExpand = (event) => {
    event.preventDefault();
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".relative")) {
        setIsExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative">
      {/* Icon Button */}
      <button
        onClick={toggleExpand}
        className="flex items-center"
        aria-expanded={isExpanded}
        aria-controls="profile-menu"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icon_user.svg`}
          alt="User Icon"
          className="w-5 h-5 object-contain hover:opacity-80"
        />
      </button>

      {/* Dropdown Content */}
      {isExpanded && (isAuthenticated? <AuthenticatedProfile />: <UnauthenticatedProfile />)}
      
    </div>
  );
};

export { MyProfile };
